import { useEffect } from 'react';

/**
 * Signals scripts/prerender.js that this view's content is ready to snapshot, by setting a
 * data attribute on <body> the Puppeteer build step polls for. Defaults to firing immediately
 * (static content) -- pass `ready={false}` until real data has arrived if a view needs to gate
 * on something other than mount (e.g. an initial fetch).
 */
export default function usePrerenderReady(ready = true) {
  useEffect(() => {
    if (ready) {
      document.body.dataset.prerenderReady = 'true';
    }
  }, [ready]);
}